export default {
    name: "PrinterManage",
    data() {
        return {
            searchForm: {
                companyName: '',
                pageNum: 1,
                pageSize: 50
            },
        }
    },
    methods: {
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageNum = val;
            this.doSearch();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        doSearch() {

        },
        doAdd(){
            const conditionData = new Object();
            conditionData.searchForm = this.searchForm;
            this.$routerUtil.setParam(conditionData);
            this.$router.push('addPrinter');
        },
        doEdit(){

        },
        doDelete() {

        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        doReset(){
            this.searchForm.companyName = '';
        }
    }
}